import { InputField } from './InputField'
import { FlatFieldSet, RedText, Label } from '../../style/StyledElement'

export const InputFieldSet = ({
  name,
  readOnly,
  placeholder,
  onChange,
  onBlur,
  mandatory,
  label,
  inputRef,
  type,
  useName,
  error,
  errorIcon = '🚫',
}) => {
  return (
    <div>
      <FlatFieldSet>
        <Label htmlFor={name}>
          {label && (mandatory ? <span className="mandatory sign-in-title">{label}</span> : <span className="sign-in-title">{label}</span>)}
        </Label>
        <InputField
          readOnly={readOnly}
          name={name}
          useName={useName}
          onChange={onChange}
          onBlur={onBlur}
          inputRef={inputRef}
          type={type ? type : 'text'}
          error={error}
          placeholder={placeholder}
        />
      </FlatFieldSet>
      {error && (
        <RedText>
          {errorIcon} {error}
        </RedText>
      )}
    </div>
  )
}
